export const MODEL_FILTER_TYPES = {
  TYPE: 'TYP',
  BRAND: 'MÄRKE',
  MODEL: 'MODELL'
};

export const MODEL_FILTER_KEYS = {
  [MODEL_FILTER_TYPES.TYPE]: 'type',
  [MODEL_FILTER_TYPES.BRAND]: 'brand',
  [MODEL_FILTER_TYPES.MODEL]: 'model'
};

/**
 * The order of keys is important. It defines the hierarchy and the index in the multi-list filter.
 * 0: type, 1: brand, 2: model
 */
export const FILTER_KEYS = ['type', 'brand', 'model'];
